<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/WorkEnvSurvey/Details/CatReport'

    export default {
        components: {
            Grid,
        }
    }
</script>